<template>
    <FilterModal :filterable="__('general.time_frame')"
                 :value="dateRangeString"
                 :filters-changed="filtersChanged"
                 @apply="$emit('input', range)"
    >
        <div class="d-flex flex-column gap-3">
            <div class="row">
                <div v-if="hasDailyFilter" class="col-md-4">
                    <div class="font-weight-bold text-uppercase p-1 text-muted">
                        {{ __('general.day') }}
                    </div>
                    <div class="d-flex flex-column gap-1">
                        <button class="btn btn-sm btn-light-primary" @click="setToToday">
                            {{ __('general.today') }}
                        </button>
                        <button class="btn btn-sm btn-light-primary" @click="setToYesterday">
                            {{ __('general.yesterday') }}
                        </button>
                        <button class="btn btn-sm btn-light-primary" @click="setToLastSevenDays">
                            {{ __('general.past_7_days') }}
                        </button>
                        <button class="btn btn-sm btn-light-primary" @click="setToLastThirtyDays">
                            {{ __('general.past_30_days') }}
                        </button>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="font-weight-bold text-uppercase p-1 text-muted">
                        {{ __('general.month') }}
                    </div>
                    <div class="d-flex flex-column gap-1">
                        <button class="btn btn-sm btn-light-primary" @click="setToThisMonth">
                            {{ __('general.this_month') }}
                        </button>
                        <button class="btn btn-sm btn-light-primary" @click="setToLastMonth">
                            {{ __('general.last_month') }}
                        </button>
                        <button class="btn btn-sm btn-light-primary" @click="setToLastQuarter">
                            {{ __('general.last_quarter') }}
                        </button>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="font-weight-bold text-uppercase p-1 text-muted">
                        {{ __('general.year') }}
                    </div>
                    <div class="d-flex flex-column gap-1">
                        <button class="btn btn-sm btn-light-primary" @click="setToThisYear">
                            {{ __('general.this_year') }}
                        </button>
                        <button class="btn btn-sm btn-light-primary" @click="setToLastYear">
                            {{ __('general.last_year') }}
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <hr>
            </div>
            <DatePicker class="border-0"
                        color="purple"
                        :columns="$screens({ default: 1, md: 2 , xl: 3 })"
                        :max-date="new Date()"
                        is-expanded
                        is-range
                        show-weeknumbers
                        v-model="range"
            />
        </div>
    </FilterModal>
</template>

<script>
import FilterModal from '@components/Stats/FilterModal.vue';
import Checkbox from '@components/Form/Checkbox.vue';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';

export default {
    components: {Checkbox, FilterModal, DatePicker},

    props: {
        value: Object,
        hasDailyFilter: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            range: this.value,
        };
    },

    methods: {
        setToToday() {
            this.range = {
                start: new Date(new Date().setHours(0, 0)),
                end: new Date(),
            };
        },
        setToYesterday() {
            this.range = {
                start: new Date((new Date(new Date() - this.millisecondsPerDay)).setHours(0, 0, 0)),
                end: new Date((new Date(new Date() - this.millisecondsPerDay)).setHours(23, 59, 59)),
            };
        },
        setToLastSevenDays() {
            this.range = {
                start: new Date((new Date(new Date() - this.millisecondsPerDay * 7)).setHours(0, 0, 0)),
                end: new Date(),
            };
        },
        setToLastThirtyDays() {
            this.range = {
                start: new Date((new Date(new Date() - this.millisecondsPerDay * 30)).setHours(0, 0, 0)),
                end: new Date(),
            };
        },
        setToThisMonth() {
            this.range = {
                start: new Date(new Date(new Date().setDate(1)).setHours(0, 0, 0)),
                end: new Date(),
            };
        },
        setToLastMonth() {
            this.range = {
                start: new Date(new Date(new Date(new Date().setMonth(new Date().getMonth() - 1)).setDate(1)).setHours(0, 0, 0)),
                end: new Date(new Date(new Date().setDate(1)).setHours(0, 0, 0)),
            };
        },
        setToLastQuarter() {
            this.range = {
                start: new Date(new Date(new Date(new Date().setMonth(new Date().getMonth() - 2)).setDate(1)).setHours(0, 0, 0)),
                end: new Date(),
            };
        },
        setToThisYear() {
            this.range = {
                start: new Date(new Date(new Date().setMonth(0, 1)).setHours(0, 0, 0)),
                end: new Date(),
            };
        },
        setToLastYear() {
            this.range = {
                start: new Date(new Date(new Date().setFullYear(new Date().getFullYear() - 1, 0, 1)).setHours(0, 0, 0)),
                end: new Date(new Date(new Date().setFullYear(new Date().getFullYear() - 1, 11, 31)).setHours(23, 59, 59)),
            };
        },
    },

    computed: {
        dateRangeString() {
            return `${this.$localDate(this.value.start)} - ${this.$localDate(this.value.end)}`;
        },

        millisecondsPerDay() {
            return 24 * 60 * 60 * 1000;
        },

        filtersChanged() {
            return this.value !== this.range;
        },
    },
};
</script>
